import React from "react";
import { useTranslation } from "react-i18next";
import {PlusIcon} from "~/assets/svg/InterfaceIcon";

const CardBack = ({ userInfo, userProfile, setProfileEditModal }) => {
	const { t } = useTranslation();
	return (
		<section className="c__card back">
			<div className="content-wrap">
				<div className="content">
					<div className="add_button_wrap">
						<button className="add-button" onClick={() => setProfileEditModal(true)}>
							<PlusIcon/>
						</button>
					</div>
					<dl className="c__form">
						<div className="f__group">
							<dt className="f__label">
								{t("pages.myPage.AccountPage.components.CardBack.name")}
							</dt>
							<dd className="f__control">{userProfile.name || "-"}</dd>
						</div>
						<div className="f__group">
							<dt className="f__label">
								{t("pages.myPage.AccountPage.components.CardBack.email")}
							</dt>
							<dd className="f__control">{userInfo.id || "-"}</dd>
						</div>
						<div className="f__group">
							<dt className="f__label">
								{t("pages.myPage.AccountPage.components.CardBack.department")}
							</dt>
							<dd className="f__control">{userProfile.department || "-"}</dd>
						</div>
						<div className="f__group">
							<dt className="f__label">
								{t("pages.myPage.AccountPage.components.CardBack.position")}
							</dt>
							<dd className="f__control">{userProfile.position || "-"}</dd>
						</div>
						<div className="f__group">
							<dt className="f__label">
								{t("pages.myPage.AccountPage.components.CardBack.division")}
							</dt>
							<dd className="f__control">
								{userInfo.role === "admin"
									? t("pages.myPage.userType.admin")
									: userInfo.role === "user"
									? t("pages.myPage.userType.member")
									: t("pages.myPage.userType.member")}
							</dd>
						</div>
					</dl>
				</div>
			</div>
		</section>
	);
};

export default CardBack;
